<forge-text-field [invalid]="isInvalid" density="small" required>
  <input #input [type]="fieldType" [autocomplete]="autocomplete" [name]="controlName" [formControl]="formControl">

  @if (!hideLabel) {
    <label [for]="controlName">
      {{label}}
    </label>
  }

  <forge-icon-button slot="end" dense (click)="onVisibilityClick($event)" aria-label="show password">
    <forge-icon [name]="visibilityIcon"></forge-icon>
    <forge-tooltip>{{visibilityTooltip}}</forge-tooltip>
  </forge-icon-button>

  @if (isCapsLockOn) {
    <forge-icon slot="end" name="alert_circle_outline">
      <forge-tooltip>CAPS lock is on</forge-tooltip>
    </forge-icon>
  }

  @if (isCapsLockOn) {
    <span slot="support-text-end">CAPS lock is on</span>
  }

  <span slot="support-text" class="error">
    @if (showErrorMessage('required')) {
      {{label}} is required
    }

    @if (hasCustomValidators) {
      @for (customError of customErrors; track customError) {
        @if (showErrorMessage(customError.errorKey)) {
          {{customError.message}}
        }
      }
    }
  </span>
</forge-text-field>